import React, { useState } from 'react'
import { Row, Col, Container, Form, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import './Style.css';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { useProjectName } from '../../../Context/ProjectNameContext';

const RecoverAccount = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    recoveryContact: "",
  });

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value
    }));
  };

  const handleRecover = async (e) => {
    e.preventDefault();

    if (!formData.recoveryContact) {
      toast.error("Please enter your email.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/recover-account`,
        {
          recoveryContact: formData.recoveryContact,
          type: "email"
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      toast.success(response.data.message || "Recovery link sent!");
      setFormData({ recoveryContact: "" });

    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to send recovery request.");
      }
    }
  };

  const projectName = useProjectName();

  return (
    <>
      <section className="sign-in-page" style={{ height: "100lvh" }}>
        <Container className="p-0" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          
          <div
            style={{ fontSize: "30px", letterSpacing: "4px", color: "white", fontWeight: "600" }}
            className={window.innerWidth <= 768 ? "mobile-margin-top" : ""}
          >
            {projectName}
          </div>

          <Row className="no-gutters" style={{ borderRadius: "10px", overflow: "hidden", justifyContent: "center", display: "flex", margin: "20px" }}>
            <Col md="12" className="bg-white pt-5 pb-5" style={{ width: "400px" }}>
              <div className="sign-in-from" style={{ paddingInline: "20px" }}>
                <h3 className="mb-0">Recover Account</h3>

                <Form className="mt-4" onSubmit={handleRecover}>
                  <Form.Group className="form-group">
                    <Form.Label className="required-label">Email address</Form.Label>
                    <Form.Control
                      type="email"
                      id="recoveryContact"
                      placeholder="Enter your email"
                      value={formData.recoveryContact}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <Link to="/auth/login" style={{ fontSize: "14px" }}>
                      Back to Login
                    </Link>

                    <Button variant="primary" type="submit">
                      Recover Account
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>

        </Container>
      </section>

      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default RecoverAccount;
